export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Lavender.9b548e8a.jpg";